import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { API_PLATFORM_URL } from '@core/config/api-base-url';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticationService {
  constructor(
    private msalService: MsalService,
    private readonly http: HttpClient,
    @Inject(API_PLATFORM_URL) private readonly apiPlatformUrl: string
  ) {}

  get user(): AccountInfo {
    return this.msalService.instance.getAllAccounts()[0];
  }

  get userName(): string {
    // tslint:disable-next-line: no-non-null-assertion
    return this.user ? this.user.name! : '';
  }

  checkUserRole(roleName: string): boolean {
    return (this.user.idTokenClaims as any)['groups'].includes(roleName);
  }

  logout(): void {
    this.msalService.logout();
  }

  getPermissions(): Observable<Record<string, string[]>> {
    return this.http.post<Record<string, string[]>>(
      `${this.apiPlatformUrl}/Permissions`,
      null
    );
  }
}
